// text contents for Home.tsx
export const home = {
	adminDashboard: {
		title: `Welcome Admin`,
		body: `Download the complete agreement list report in CSV format.`,
		body2: `Replace the Data Sharing Agreement PDF Template`,
	},
};
